import React, { useContext } from "react";
import { RadioButton } from "primereact/radiobutton";
import { SettingsContext } from "./SettingsContext.tsx";
import { DecimalPlacesOptions, DecimalMaxWholeOptions } from "../Constants.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two dials a decimal sheet needs: how many decimal places the numbers run
 * to, and how large their whole-number part gets.
 *
 * Place counts are drawn independently per operand up to this maximum, so a
 * sheet set to three places still mixes one-, two- and three-place numbers -
 * lining those up is the skill the format exists to teach. Setting it to one
 * gives a first sheet where every number has one place and the alignment
 * problem does not arise yet.
 */
export function DecimalSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handlePlacesChange(event) {
        setSettings({ ...settings, DecimalPlaces: Number(event.target.value) });
    }

    function handleWholeChange(event) {
        setSettings({ ...settings, DecimalMaxWhole: Number(event.target.value) });
    }

    return (
        <div className="decimalSettingsContainer">
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.decimalPlacesLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.decimalPlacesAria')}>
                {DecimalPlacesOptions.map((places) => (
                    <div key={places}>
                        <RadioButton
                            inputId={`decimalPlaces-${places}`}
                            value={places}
                            checked={settings.DecimalPlaces === places}
                            onChange={handlePlacesChange}
                        />
                        <label htmlFor={`decimalPlaces-${places}`}>{places}</label>
                    </div>
                ))}
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestWholeNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestWholeNumberAria')}>
                {DecimalMaxWholeOptions.map((whole) => (
                    <div key={whole}>
                        <RadioButton
                            inputId={`decimalWhole-${whole}`}
                            value={whole}
                            checked={settings.DecimalMaxWhole === whole}
                            onChange={handleWholeChange}
                        />
                        <label htmlFor={`decimalWhole-${whole}`}>{whole}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DecimalSettings;
